module.exports = __webpack_public_path__ + "static/pbhead-62a022a8b69c0f5203664ef68e3e8a58.png";